import { createUseStyles } from 'react-jss';

import { FontWeight } from '../../../../styles';
import { ITheme } from '../../../../styles/theme';

const useStyles = createUseStyles(
  ({ spacing, colors }: ITheme) => ({
    root: {
      display: 'inline-flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: spacing.small,

      width: '220px',
    },
    indicator: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',

      width: 48,
      minWidth: 48,
      height: 48,
      minHeight: 48,

      background: 'var(--x-bg-1)',
      borderRadius: '50%',

      boxShadow: '0px 1px 4px var(--x-shadow-card)',

      color: colors.primary,
      fontSize: `16px`,

      userSelect: 'none',
    },
    text: {
      flex: 1,
      textAlign: 'center',
    },
    title: {
      marginBottom: spacing.small,
      fontWeight: `${FontWeight.Medium} !important`,
      fontSize: '20px !important',
    },
    description: {
      fontSize: '14px !important',
      lineHeight: '20px !important',
      fontWeight: `${FontWeight.Medium}`,
    },
  }),
  {
    name: 'step-with-description',
  },
);

export default useStyles;
